/* eslint-disable no-undef */
import { LitElement, html, css } from 'lit'
import { ifDefined } from 'lit/directives/if-defined.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { shopifyCart } from '../../../api/cart'
import { centsToDollars, resizeImageSrc, dropZeros, debounce, changeDecimalSeparator } from '../../lib/utils'
import { get } from '../../lib/ajax'
import $ from 'quantdom'

export class CartDrawer extends LitElement {
  static styles = [
    css`
      :host {
        width: 100%;
        height: 100%;
        z-index: 1000001;
      }

      * {
        font-family: 'TWK Lausanne', 'Arial', sans-serif;
        color: #1E262A;
      }

      h3.cart-drawer_title {
        font-size: 16px;
        font-weight: 200;
        line-height: 14px;
        text-align: left;
        margin: 0;
      }

      .font-light {
        font-weight: 300;
      }

      button {
        cursor: pointer;
      }

      .relative {
        position: relative;
      }

      .flex {
        display: flex;
      }

      .hidden {
        display: none !important;
      }

      .flex-col {
        flex-direction: column;
      }

      .justify-between {
        justify-content: space-between;
      }

      .items-center {
        align-items: center;
      }

      .self-center {
        align-self: center;
      }

      .flex-1 {
        flex: 1 1 0%;
      }

      .font-bold {
        font-weight: 700;
      }

      .margin-t-xs {
        margin-top: 8px;
      }

      .margin-t-sm {
        margin-top: 10px;
      }

      .mt-3 {
        margin-top: 12px;
      }

      .mt-5 {
        margin-top: 20px;
      }

      .margin-b-xs {
        margin-bottom: 3px;
      }

      .text-center {
        text-align: center;
      }

      .strikeout {
        text-decoration: line-through;
      }

      .font-red {
        color: #f93822 !important;
      }

      .strikethrough-grey {
        color: #1E262A;
        opacity: 1;
        font-weight: 100;
        padding-right: 4px;
      }

      header {
        padding: 20px 20px 0;
      }

      free-shipping-progress {
        margin: 20px 0 0 0;
        padding: 0 0 20px 0;
        border-bottom: 1px solid rgb(238, 236, 235);
      }

      .empty-cart .empty-cart_details button {
        font-size: 14px;
      }

      .cart-drawer_header {
        padding: 10px 0px;
        background-color: #fefbf9;
      }

      .cart-drawer_header-details {
        /* border-bottom: 0.5px solid #ced3d3; */
        display: flex;
        align-items: flex-end;
        padding: 0 20px;
        column-gap: 8px;
      }

      .gift-with-purchase_one-time-header {
        display: flex;
        justify-content: center;
        padding: 8px 12px;
        background-color: #dedeb1;
        border-radius: 0px 0px 5px 5px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
        color: var(--primary-navy, #1f3337);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
      }

      @media (max-width: 430px) {
        header {
          padding: 20px 0 0 0;
        }
      }

      .cart-drawer_cart-count {
        font-size: 16px;
        line-height: 14px;
        font-weight: 200;
        margin: 0;
      }

      .hide-element-empty-cart {
        display: none !important;
      }

      .bundle {
        margin: 8px 0 0 0;
        font-size: 12px;
        font-weight: bold;
      }

      .cart-drawer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
      }

      .cart-item .right {
        width: 100%;
      }

      .cart-item-single-bucket {
        background-color: #fff;
        box-shadow: 0px 0px 5px 0px #0000000d;
        border-radius: 20px;
        border: 1px solid #e6c4c7;
        margin: 16px 0px;
        list-style-type: none;
        padding: 0px;
      }

      .gwp-enabled .cart-item-single-bucket:first-child {
        margin-top: 0px;
      }

      .gwp-enabled .cart-item-list {
        margin-block-start: 0px;
      }

      .cart-item-delete {
        min-width: 116px;
        width: 100%;
        scroll-snap-align: end;
      }

      .cart-item-subscription {
        margin-bottom: 6px;
        font-size: 10px;
        color: #978f90;
        display: flex;
        align-items: center;
      }

      /* @media (min-width: 431px) {
      .cart-item {
        width: 100%;
      }
    } */

      .cart-item .cart-item_border {
        padding: 15px 0;
        gap: 10px;
      }

      .cart-item_container {
        padding: 10px 15px;
        gap: 8px;
        position: relative;
      }

      .cart-item-list {
        padding: 0px;
        list-style-type: none;
        margin: 30px 20px;
      }

      @media(min-width:700px){
        .cart-item-list {
          margin: 30px 30px;
        }
      }

      .cart-drawer .cart-item:not(:last-child) .cart-item_border {
        border-bottom: 0.5px solid #eeeceb;
      }

      .cart-item > .right {
        margin-left: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .cart-item_image-container {
        position: relative;
      }

      .cart-item img.cart-item_image {
        height: 100%;
        object-fit: cover;
        max-width: 70px;
        margin: 0 auto;
        border-radius: 10px;
        border: 1px solid #e6c4c7;
      }

      @media (min-width: 700px) {
        .cart-item img.cart-item_image {
          max-width: 65px; /* was 80px */
          height: auto;
        }
      }

      .cart-item_plan-count {
        font-size: 10px;
        line-height: 10px;
        letter-spacing: 0em;
        padding: 8px 10px;
        position: absolute;
        background-color: #fff;
        top: 4px;
        left: 4px;
        border-radius: 6px;
      }

      .cart-item_variant-title {
        display: flex;
        justify-self: center;
        align-self: center;
        align-items: center;
        gap: 2px;
        text-transform: uppercase;
        color: #25282A;
        font-weight: 100;
        font-size: 0.8rem;
      }

      .cart-drawer {
        border-top: 1px solid #eeeceb;
        font-size: 14px;
      }

      .cart-drawer .cart-drawer_products-container {
        display: flex;
        flex-direction: column;
        min-height: 0;
        height: 100%;
        background-color: #fefbf9;
        overflow-y: scroll;
      }

      .cart-drawer .cart-drawer_products-line-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        background-color: #fff;
      }

      .cart-drawer .cart-drawer_products {
        padding: 0 20px 20px 20px;
        list-style-type: none;
        margin: 0;
        background: #fff;
      }

      .cart-drawer_bottom {
        padding: 20px;
        background: #fefbf9;
        font-size: 16px;
        font-weight: 300;
      }

      @media (min-width: 700px) {
        .cart-drawer_bottom {
          padding: 10px 40px;
        }
      }

      .cart-drawer_bottom-payments {
        font-weight: 100;
        font-size: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 4px;
        color: #1E262A;
      }

      .cart-drawer_value-props {
        display: flex;
        background-color: #25101d;
        color: white !important;
        justify-content: center;
        align-items: center;
        padding: 6px 20px;
        gap: 10px;
      }

      .cart-drawer_value-props div {
        color: white !important;
      }

      @media (max-width: 500px) {
        .cart-drawer_value-props {
          gap: 8px;
          font-size: 2.7vw;
        }
      }

      .cart-drawer_bottom-savings {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .cart-drawer_bottom-label {
        font-size: 17px;
        font-weight: 500;
      }

      .cart-drawer_bottom-label > * {
        color: #1E262A;
      }

      .cart-drawer_bottom-total {
        display: flex;
        align-items: center;
        column-gap: 12px;
      }

      .cart-drawer_bottom__message {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1E262A;
        padding-top: 16px;
        gap: 5px;
      }

      .cart-drawer_bottom__message span {
        font-weight: 100;
        color: #1E262A;
        font-size: 14px;
      }

      .cart-drawer_bottom ul {
        padding-inline-start: 0;
      }

      button.close-btn {
        background: none;
        border: none;
        cursor: pointer;
        position: absolute;
        right: 0px;
        top: 5px;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type='number'] {
        -moz-appearance: textfield;
      }

      .cart-item--price-quantity{
        display: flex;
        flex-direction: column;
      }

      .quantity-selector {
        width: 75px;
        border: 1px solid #e6c4c7;
        border-radius: 4px;
        padding: 7px 12px;
        margin-top: auto;
      }

      .quantity-selector input,
      .quantity-selector button {
        background: none;
        border: none;
        text-align: center;
        padding: 0;
      }

      .quantity-selector button {
        justify-content: center;
        display: flex;
        align-items: center;
      }

      button.remove-btn {
        border: solid 1px #627073;
        border-radius: 2px;
        background-color: #fff;
        line-height: 1;
        padding: 0 10px;
        margin-left: 5px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .remove-btn_icon {
        width: 9px;
      }

      .quantity-selector > button,
      .quantity-selector > input[type='number']:disabled,
      button.remove-btn {
        color: #1E262A;
        -webkit-text-fill-color: #1E262A;
        opacity: 1; /* required on iOS */
        width: 100%;
        max-width: 30px;
        font-size: 14px;
      }

      .left {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .loading-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background: rgba(255, 255, 255, 0.75);
        z-index: 2;
      }
      /* Remove in order to make loader opacity */
      /* .cart-drawer[loading="true"] .cart-drawer_bucket-container,
    .cart-drawer[loading="true"] .cart-drawer_upsells {
      display: none;
    } */

      .cart-drawer[loading='false'] .loading-container {
        display: none;
      }

      h5 {
        margin: 0;
        font-size: 16px;
      }

      .empty-cart {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: #f6f4f2;
      }

      .empty-cart_details {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 330px;
        margin: 0 auto 50% auto;
      }

      a {
        text-decoration: none;
      }

      .empty-cart_text {
        text-align: center;
        font-size: 24px;
        margin-top: 0px;
        margin-bottom: 0px;
        line-height: 24px;
        white-space: pre;
        padding: 25px 15px;
        background-color: #fefbf9;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
      }

      .empty-cart_image {
        height: auto;
        width: 100%;
        max-width: 330px;
        margin: 0 auto;
        position: relative;
        top: 30px;
      }

      .empty-cart-bogo_wrapper {
        text-align: center;
        margin-top: 0px;
        margin-bottom: 0px;
        background-color: #fff;
        height: 100%;
        display: flex;
        align-items: center;
        font-weight: 300;
        flex-direction: column;
      }

      .empty-cart-bogo_promo-message {
        font-size: 17px;
      }

      .empty-cart-bogo_promo-message p {
        margin: 0;
      }

      .empty-cart-bogo_promo-message a {
        display: block;
        width: 100%;
        padding: 10px 0px;
        border: 1px solid #1E262A;
        margin-top: 11px;
        border-radius: 24px;
      }

      .empty-cart-bogo_promo-message a:hover {
        background: #1E262A;
        color: #fff;
      }

      .empty-cart-bogo_promo-message strong {
        font-weight: normal;
        padding-top: 20px;
        padding-bottom: 5px;
        display: block;
      }

      .empty-cart-bogo_reviews {
        margin-top: 15%;
      }

      .empty-cart-bogo_reviews img {
        display: block;
        margin: 0 auto 10px auto;
      }

      .empty-cart-bogo_reviews p {
        font-size: 24px;
        margin: 10px;
      }

      .gap-1 {
        gap: 4px;
      }

      .gap-2 {
        gap: 8px;
      }

      .line-item-delivery-cadence {
        font-size: 12px;
      }

      .line-item-options-row {
        gap: 8px;
      }

      .title {
        color: #1E262A;
        font-size: 14px;
        font-weight: 100;
        line-height: 132%;
      }

      .type {
        color: #231f20;
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 130%;
      }

      .price-container {
        display: flex;
        flex-direction: row;
        gap: 4px;
        justify-content: flex-end;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 500;
      }

        @media (min-width: 700px) {
        .price-container
          font-size: 18px;
        }
      }

      .price-container small {
        display: block;
        position: absolute;
        right: 10px;
        font-size: 12px;
      }

      .free-text {
        color: #E71D06;
      }

      .variant-option {
        color: #6e6e73;
        font-size: 10px;
        display: flex;
        line-height: 148%;
      }

      /* Upsells */
      .cart-drawer_upsells {
        padding: 25px 0 15px 17px;
        background-color: #faf3f4;
      }

      .side-cart-upsell-card-header {
        font-size: 15px;
        font-weight: 400;
        margin-top: 0px;
        margin-bottom: 16px;
        color: #1E262A;
      }

      .cart-drawer_upsells-container {
        display: flex;
        flex-direction: column;
      }

      .side-cart-upsell-card-image-container {
        position: relative;
        display: flex;
        align-self: start;
      }

      .side-cart-upsell-card-image-container img {
        aspect-ratio: 1;
        object-fit: cover;
        display: flex;
        align-self: center;
        border-radius: 10px;
        max-width: 60px;
        max-height: 60px;
        border: 1px solid #e6c4c7;
      }

      .side-cart-upsell-card-add-button {
        width: auto;
        padding: 6px 16px !important;
        font-size: 14px !important;
        display: block !important;
        margin-left: auto !important;
        border-radius: 100px;
        border: 1px solid #25101d;
        background-color: #fff;
        text-transform: uppercase;
        font-weight: 500;
      }

      .cart-drawer_upsells-container.is-empty {
        display: hidden;
      }

      .side-cart-upsell-products-container {
        position: relative;
      }

      .side-cart-upsell-products-container
        :is(.side-cart-upsell-right-arrow-container, .side-cart-upsell-left-arrow-container) {
        display: none;
      }

      .side-cart-upsell-products-container.upsell-for-empty-cart .side-cart-upsell-products {
        flex-direction: column;
        max-width: 90%;
      }

      .side-cart-upsell-products-container.upsell-for-empty-cart .side-cart-upsell-card {
        flex-basis: 100%;
        width: 100%;
      }

      .side-cart-upsell-products-container.upsell-for-empty-cart
        .side-cart-upsell-products
        li:not(li:first-child, li:nth-child(2)) {
        display: none;
      }

      .side-cart-upsell-right-arrow-container {
        background-color: #25101d;
        position: absolute;
        top: 50%;
        right: 10px;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        translate: 0 -50%;
        border: none;
      }

      .side-cart-upsell-left-arrow-container {
        background-color: #25101d;
        position: absolute;
        top: 50%;
        left: 10px;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        translate: 0 -50%;
        border: none;
        rotate: 180deg;
      }

      .side-cart-upsell-products {
        display: flex;
        list-style-type: none;
        padding: 0px;
        margin: 0px;
        flex-wrap: nowrap;
        gap: 14px;
        width: fit-content;
        
        /*  REMOVE TO BE A SLIDER */
        flex-direction: column;
        width: calc(100% - 25px);
      }

      .side-cart-upsell-products-full {
        width: calc(100% - 25px);
      }

      .side-cart-upsell-card {
        background-color: #fff;
        display: flex;
        flex-direction: row;
        padding: 16px;
        scroll-snap-align: start;
        border-radius: 20px;

        /*  REMOVE TO BE A SLIDER */
        width: calc(100% - 25px);

        /*UNCOMMENT TO BE A SLIDER*/
         /* width: 300px; */
      }

      .side-cart-upsell-card-full {
        width: 100%;
      }

      .side-cart-upsell-card-details {
        display: flex;
        flex-grow: 1;
      }

      .side-cart-upsell-card-desc-container {
        /* display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 8px; 
                border-radius: 0px 0px 5px 5px;
        */

        display: grid;
        grid-template-columns: 70% 30%;
        grid-template-rows: repeat(2, 1fr);
        align-items: baseline;

        background: #fff;
        width: 100%;
        padding-left: 8px;
      }

      .side-cart-upsell-card-title {
        grid-column: 1 / 2;
        grid-row: 1 / 3;
        padding-right: 10px;
        font-size: 14px;
        font-weight: 300;
        line-height: 23px;
      }

      .side-cart-upsell-card-category {
        color: #627073;
        font-size: 12px;
        font-weight: 300;
        line-height: 132%;
      }

      .side-cart-upsell-card-price-container {
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
        gap: 4px;
      }

      .side-cart-upsell-card-price {
        font-size: 15px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0px;
      }

      .side-cart-upsell-card-compare-price {
        font-size: 15px;
        font-weight: 100;
        text-decoration: line-through;
      }

      /* Buckets */
      .cart-bucket {
        background-color: rgb(255, 255, 255);
        border: 1px solid #E6C4C7;
        margin: 16px;
        list-style-type: none;
        padding: 0px;
        border-radius: 20px;
        overflow: hidden;
      }

      .cart-bucket .cart-item:first-of-type {
          border-bottom: 1px solid #E6C4C7;
      }

      .cart-bucket-footer {
        background-color: #FAF3F4;
        display: flex;
        align-items: center;
        padding: 8px 17px;
        gap: 8px;
      }
      
      .cart-bucket-footer.bogo-applied {
        justify-content: flex-end;
      }

      .cart-bucket-footer.bogo-applied span {
        color: #E71D06;
      }
      
      .cart-bucket-footer p {
        margin: 0
      }

      .cart-bucket-footer a {
        text-decoration: underline;
        font-weight: 500;
        padding-left: 5px;
      }

      /* Empty Cart Tiles */
      .empty-cart_tiles-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        padding: 24px 38px;
      }

      .empty-cart_tile-card {
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px #0000000d;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .empty-cart_tile-image {
        aspect-ratio: 1;
        width: 100%;
      }

      .empty-cart_tile-label {
        color: #1f3337;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        margin: 0;
        padding: 8px;
        background-color: #fff;
      }

      /* Help Card */
      .empty-cart_help-card {
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 0px 5px 0px #0000000d;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;
        margin: 0 38px;
        gap: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #1f3337;
      }

      .empty-cart_shop-all {
        color: #87893e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%; /* 18px */
        letter-spacing: 1px;
      }

      /* Empty Cart Tiles */
      .empty-cart_tiles-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        padding: 24px 38px;
      }

      .empty-cart_tile-card {
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px #0000000d;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .empty-cart_tile-image {
        aspect-ratio: 1;
        width: 100%;
      }

      .empty-cart_tile-label {
        color: #1f3337;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        margin: 0;
        padding: 8px;
        background-color: #fff;
      }

      /* Help Card */
      .empty-cart_help-card {
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 0px 5px 0px #0000000d;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;
        margin: 0 38px;
        gap: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #1f3337;
      }

      .empty-cart_shop-all {
        color: #87893e;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%; /* 18px */
        letter-spacing: 1px;
      }

      /* Primary Button */
      .btn-primary {
        min-height: 48px;
        width: 100%;
        border-radius: 9999px;
        background-color: rgb(231 29 6 / 1);
        margin-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-family: TWK Lausanne, Arial, sans-serif;
        font-size: 16px;
        line-height: 1.25rem;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        transition: background-color 300ms ease-in-out, box-shadow 300ms ease-in-out;
      }

      @media (hover: hover) and (pointer: fine) {
        .btn-primary:hover {
          color: #fff;
          box-shadow: 0px 0px 20px 0px #f9382240;
        }
      }

      .btn-primary:active {
        background-color: rgb(249 56 34 / 1);
        box-shadow: 0px 0px 20px 0px #f9382280;
      }

      .btn-primary:disabled {
        pointer-events: none;
        opacity: 0.5;
      }

      .btn-primary[aria-disabled='true'] {
        pointer-events: none;
        opacity: 0.5;
      }

      button#checkout {
        text-transform: uppercase;
        color: white;
        margin-top: 16px;
      }

      .lock-icon {
        height: 14px;
        color: #fff;
        margin-right: 4px;
      }

      /* Secondary Button */
      .btn-secondary {
        padding: 11px 16px;
        font-size: 14px;
        border-radius: 100px;
        border: 1px solid #25101d;
        background-color: #fff;
        outline-offset: 2px;
      }

      .btn-secondary:hover {
        color: #fff;
        background: linear-gradient(90deg, #25101d 0%, #54414e 49.48%, #25101d 100%);
        border: 1px solid transparent;
      }

      .btn-secondary:disabled {
        border: 1px solid #25101d;
        background: #fff;
        opacity: 0.5;
      }

      .btn-secondary:active {
        color: #fff;
        background: #4e4b48;
        border: 1px solid transparent;
      }

      /* Color Swatches */
      .variant-swatch {
        display: none;

        background: transparent;
        background-size: cover;
        width: 12px;
        height: 12px;
        border-radius: 100%;
      }
      .cart-announcement-bar {
        background-color: #faf3f4;
        color: #1E262A;
        padding: 5px 6px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: 100;
      }

      .subscription-upsell-container {
        margin: 0 8px 8px;
      }

      .subscription-upsell-btn {
        width: 100%;
      }

      .subscription-upsell-select {
        width: 100%;
        background: #fff url(https://www.solawave.co/cdn/shop/t/653/assets/dropdown_form.svg) no-repeat right 12px center !important;
        outline: none;
        padding: 9px 12px;
        border-radius: 10px;
        border: 1px solid #25101d;
        appearance: none;
      }

      a.btn-primary {
        width: auto !important;
        max-width: 410px;
      }
    `,
  ]

  static properties = {
    count: { type: Number },
    cartItems: { type: Array },
    upsells: { type: Array },
    hide: { type: Boolean },
    subtotal: { type: Number },
    originalSubTotal: { type: Number },
    lowestFrequency: { type: Number },
    loading: { type: Boolean },
  }

  constructor() {
    super()
    this.url = new URL(window.location)
    this.assets = this.url.host === '127.0.0.1:9292' ? `${this.url.origin}/assets/` : window.Solawave_Store.asset_url
    this.store = window.Solawave_Store
    this.subtotal = 0
    this.originalSubTotal = 0
    this.enableGlobale = window.enableGlobale
    this.params = this.url.searchParams
    this.itemSingularText = 'item'
    this.itemPluralText = 'items'
  }

  _setCart() {
    return new Promise(async (resolve) => {
      shopifyCart.fetchNewCart().then(async (res) => {
        this.ogSubtotal = res.total_price
        this.ogTotalSavings = 0

        let hasGWPProductThreshold = false
        if (!this.gift_with_purchase.product_threshold?.id) {
          hasGWPProductThreshold = true
        } else {
          const gwpProductThreshold = res.items.find(
            (item) => item.product_id == this.gift_with_purchase.product_threshold?.id
          )

          if (this.gift_with_purchase.product_threshold_subscription) {
            hasGWPProductThreshold = !!gwpProductThreshold?.selling_plan_allocation
          } else {
            hasGWPProductThreshold = !!gwpProductThreshold
          }
        }
        let hasGWPProductExclude = false
        for (let item of res.items) {
          let maxPrice = item.line_compare_at_price || item.original_line_price
          this.ogTotalSavings += maxPrice - item.line_price
          if (item.product_id == this.gift_with_purchase.exclude_product?.id) {
            hasGWPProductExclude = true
          }
        }
        this.hasSubscription =
          res.items.filter((item) => item?.hasOwnProperty('selling_plan_allocation') == true)?.length > 0 ? true : false
        this.cartToken = res.token
        this.count = res.item_count
        window.MicroBus.emit('count-change', { count: this.count })
        let gwp_total_price = res.total_price
        if (this.gift_with_purchase.consider_original_price) {
          gwp_total_price = res.original_total_price
        }
        this.gwpActive =
          this.gift_with_purchase.enabled &&
          gwp_total_price >= this.gift_with_purchase.threshold &&
          hasGWPProductThreshold &&
          !hasGWPProductExclude
        this.ogTotalSavings = centsToDollars(this.ogTotalSavings)

        this.subtotal = centsToDollars(res.total_price)

        this.originalSubTotal = centsToDollars(res.original_total_price)
        this.totalSavings = centsToDollars(res.total_savings)
        this.cartItems = res.items
        this.totalCompare = centsToDollars(res.total_price + res.total_savings)
        this.itemsText = this.count === 1 ? this.itemSingularText : this.itemPluralText

        if (this.subscription_upsell.enabled) {
          if (!this.subscription_upsell.product.id) {
            for (const item of this.cartItems) {
              const js_cart_item = await this._fetchItemJSObject(item)
              if (js_cart_item.hasOwnProperty('selling_plan_groups')) {
                item['selling_plan_groups'] = js_cart_item.selling_plan_groups
              }
            }
          }
        }

        this.upsells = await this.getProductUpsells()
        resolve(res)
      })
    })
  }

  async _updateGWP() {
    return new Promise(async (resolve) => {
      const gwpItem = this.cartItems.filter((item) => item?.properties?._is_gift == true)
      try {
        if (
          this.gwpActive &&
          gwpItem.length == 0 &&
          this.cartItems.length > 0 &&
          this.gift_with_purchase.product.hasOwnProperty('variants') &&
          this.cartItems.filter((item) => item.id == this.gift_with_purchase.product?.variants[0].id).length == 0
        ) {
          shopifyCart.add(1, this.gift_with_purchase.product.variants[0].id, { _is_gift: true }, null).then(() => {
            return new Promise(async (resolveThen) => {
              await this._setCart()
              resolveThen()
              resolve()
            })
          })
        } else if (this.gwpActive == false || (this.gwpActive && this.cartItems.length == 1 && gwpItem.length > 0)) {
          await this._removeGWP()
          resolve()
        } else {
          resolve()
        }
      } catch (e) {
        console.log(e)
        resolve()
      }
    })
  }

  async _removeGWP() {
    return new Promise(async (resolve) => {
      try {
        const gwpItem = this.cartItems.filter((item) => item?.properties?._is_gift == true)
        if (gwpItem.length > 0) {
          for (let item of gwpItem) {
            await shopifyCart.change(0, item.key).then(() => {
              return new Promise(async (resolveThen) => {
                await this._setCart()
                resolveThen()
                resolve()
              })
            })
          }
        }
        resolve()
      } catch (e) {
        console.log(e)
        resolve()
      }
    })
  }

  async getProductUpsells() {
    let promises = []
    const cartIds = this.cartItems.map((item) => item.product_id)
    let nonUniqueUpsells = []
    let productList = []
    this.upsells = []

    if (this.cartItems.length > 0 && this.cartItems.length % 2 != 0 && this.bogo_enabled) {
      const cartItemsPriceDecending = [...this.cartItems].sort(this._sortByProp('discounted_price')).reverse()
      const freeItems = cartItemsPriceDecending
        .filter((item) => item.discounted_price == 0)
        .sort(this._sortByProp('original_price'))
        .reverse()
      const paidItems = cartItemsPriceDecending.filter((item) => item.discounted_price > 0)
      productList = [paidItems[paidItems.length - 1]]
    } else {
      productList = this.cartItems
    }

    productList.forEach(({ product_id }) => {
      promises.push(
        fetch(`/recommendations/products.json?product_id=${product_id}&limit=4&intent=related`).then((res) => res.json())
      )
    })

    const recs = await Promise.all(
      promises.map(async (res) => {
        const { products } = await res
        return products
      })
    )

    //zip the recs together
    for (var i = 0; i < productList.length; i++) {
      for (var n = 0; n < recs[i].length; n++) {
        if (recs[i][n]) {
          nonUniqueUpsells.push(recs[i][n])
        }
      }
    }

    const tempUnique = new Set()
    let unique = nonUniqueUpsells.filter((el) => {
      const duplicate = tempUnique.has(el.id)
      tempUnique.add(el.id)
      return !duplicate && el.available == true && cartIds.indexOf(el.id) == -1
    })

    if (this.bogo_enabled && this.cartItems.length > 0 && this.cartItems.length % 2 != 0) {
      unique.unshift(productList[0])
      return unique
    } else if (!this.bogo_enabled && this.cartItems.length > 0) {
      return unique
    } else {
      const temp = new Set()
      return this.base_upsell_list.filter((el) => {
        const duplicate = temp.has(el.id)
        temp.add(el.id)
        return !duplicate && el.available == true && cartIds.indexOf(el.id) == -1
      })
    }
  }

  uuidv4() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    )
  }

  setCartTranslations(data) {
    if (data.length > 0) {
      this.addToCartText = data[0] ? data[0] : this.addToCartText
      this.checkoutText = data[1] ? data[1] : this.checkoutText
      this.announcementText = data[2] ? data[2] : this.announcementText
      this.emptyCartButton = data[3] ? data[3] : this.emptyCartButton
      this.valuePropReturns = data[4] ? data[4] : this.valuePropReturns
      this.valuePropFreeShipping = data[5] ? data[5] : this.valuePropFreeShipping
      this.valuePropWarranty = data[6] ? data[6] : this.valuePropWarranty
      this.empty_cart.text = data[7] ? data[7] : this.empty_cart.text
      this.line_item_message_when_promo_is_not_active = data[8] ? data[8] : this.line_item_message_when_promo_is_not_active
      this.savingsText = data[9] ? data[9] : this.savingsText
      this.subTotalText = data[10] ? data[10] : this.subTotalText
      this.valueProps = data[11] ? data[11] : this.valueProps
      this.bogo_savings_message = data[12] ? data[12] : this.bogo_savings_message
      this.bogo_script_editor_discount_title = data[13] ? data[13] : this.bogo_script_editor_discount_title
      this.bogo_upsell_message = data[14] ? data[14] : this.bogo_upsell_message
      this.bogo_upsell_free_message = data[15] ? data[15] : this.bogo_upsell_free_message
      this.upsellTitleText = data[16] ? data[16] : this.upsellTitleText
      this.savedText = data[17] ? data[17] : this.savedText
      this.cartHeadingText = data[18] ? data[18] : this.cartHeadingText
      this.itemSingularText = data[19] ? data[19] : this.itemSingularText
      this.itemPluralText = data[20] ? data[20] : this.itemPluralText
      this.freeText = data[21] ? data[21] : this.freeText
      this.gift_with_purchase.progress_bar.locked_text_international = data[22]
        ? data[22]
        : this.gift_with_purchase.progress_bar.locked_text_international
      this.gift_with_purchase.progress_bar.unlocked_text_international = data[23]
        ? data[23]
        : this.gift_with_purchase.progress_bar.unlocked_text_international
      this.itemsText = data[24] ? data[24] : this.itemsText
    }
  }

  connectedCallback() {
    super.connectedCallback()

    this.count = 0
    this.cartItems = []
    this.upsells = []
    this.hide = true
    this.totalSavings = 0
    this.hasSubscription = false
    this.itemsText = this.count === 1 ? this.itemSingularText : this.itemPluralText
    this.store = window.Solawave_Store
    this.settings = this.store.settings
    // Injecting dynamic CSS for color swatches
    const template = document.getElementById('variant-swatch-styles')
    if (template && this.shadowRoot) {
      const styleContent = template.content.querySelector('style').textContent

      // Create a <style> tag to append to the shadowRoot
      const styleTag = document.createElement('style')
      styleTag.textContent = styleContent

      // Append the <style> tag to the shadowRoot
      this.shadowRoot.appendChild(styleTag)
    }
    this.empty_cart = this.settings.empty_cart
    this.emptyCartShopURL = this.empty_cart?.shop_url ?? '/collections/all'
    this.valueProps = this.settings.side_cart.value_props
    this.base_upsell_list = this.settings.side_cart.base_upsell_list
    this.base_upsell_list.map((item) => {
      item.url = `/products/${item.handle}`
    })
    this.announcementText = this.settings.cart_announcement_text
    this.discountCodeEnabled = this.settings.cart_discount_enabled
    this.gift_with_purchase = this.settings.gift_with_purchase
    this.free_shipping_threshold = this.settings.shipping.free_shipping_threshold
    this.base_shipping_price = this.settings.shipping.base_shipping_price
    this.discountLoading = false
    this.bundleMinimum = 3
    this.lowestFrequency
    this.loading = false
    this.currency_symbol = this.store.cart.currency.symbol
    this.subscription_upsell = this.settings.subscription_upsell
    this.getInitialCart() //fetch cart data and build cart html
    this.addToCartText = 'ADD'
    this.checkoutText = 'Secure Checkout'
    this.emptyCartButton = 'Shop Now'
    this.valuePropReturns = 'Easy Returns'
    this.valuePropFreeShipping = 'Free Shipping'
    this.valuePropWarranty = '1-Year Warranty'
    this.savingsText = 'Savings'
    this.subTotalText = 'Estimated SubTotal'
    this.upsellTitleText = 'Shop Bestsellers'
    this.savedText = 'SAVED'
    this.cartHeadingText = 'Your cart'
    this.freeText = 'FREE'
    this.cart_bogo_metaobject_settings = this.store.cart_bogo_metaobject_settings
    this.eligible_product_ids_array = this.cart_bogo_metaobject_settings.eligible_product_ids_array ?? []
    this.bogo_enabled = this.settings.bogo.bogo_enabled ? true : false
    this.bogo_candidate = null
    this.bogo_pair_found = false
    this.bogo_script_editor_discount_title = this.cart_bogo_metaobject_settings.bogo_script_editor_discount_title
    this.product_tag_for_bogo_eligibility = this.cart_bogo_metaobject_settings.product_tag_for_bogo_eligibility
    this.line_item_message_when_promo_is_not_active =
      this.cart_bogo_metaobject_settings.line_item_message_when_promo_is_not_active
    this.line_item_content_when_item_is_not_eligible =
      this.cart_bogo_metaobject_settings.line_item_content_when_item_is_not_eligible
    this.line_item_content_when_item_is_active = this.cart_bogo_metaobject_settings.line_item_message_when_promo_active
    this.bogo_upsell_message = this.line_item_content_when_item_is_active
    this.bogo_upsell_free_message = this.line_item_message_when_promo_is_not_active
    this.bogo_savings_message = this.settings.bogo.bogo_savings_message
    this.empty_cart_promo_message = this.cart_bogo_metaobject_settings.empty_cart_promo_message

    if (this.enableGlobale) {
      try {
        const translations = sessionStorage.getItem(`_cart-translations`)
          ? JSON.parse(sessionStorage.getItem(`_cart-translations`))
          : null
        if (translations) {
          this.setCartTranslations(translations)
        }

        const baseUpsellTranslations = sessionStorage.getItem(`_cart-translations-base-upsells`)
          ? JSON.parse(sessionStorage.getItem(`_cart-translations-base-upsells`))
          : null
        if (baseUpsellTranslations) {
          this.base_upsell_list.forEach((item, index) => {
            this.base_upsell_list[index].title = baseUpsellTranslations[index] ? baseUpsellTranslations[index] : item.title
          })
        }
        window.MicroBus.on('weglot:init', ({ detail }) => {
          const { language } = detail
          if (window?.Weglot?.translate) {
            if (!translations) {
              Weglot.translate(
                {
                  words: [
                    { t: 1, w: this.addToCartText },
                    { t: 1, w: this.checkoutText },
                    { t: 1, w: this.announcementText },
                    { t: 1, w: this.emptyCartButton },
                    { t: 1, w: this.valuePropReturns },
                    { t: 1, w: this.valuePropFreeShipping },
                    { t: 1, w: this.valuePropWarranty },
                    { t: 1, w: this.empty_cart.text },
                    { t: 1, w: this.line_item_message_when_promo_is_not_active },
                    { t: 1, w: this.savingsText },
                    { t: 1, w: this.subTotalText },
                    { t: 1, w: this.valueProps },
                    { t: 1, w: this.bogo_savings_message },
                    { t: 1, w: this.bogo_script_editor_discount_title },
                    { t: 1, w: this.bogo_upsell_message },
                    { t: 1, w: this.bogo_upsell_free_message },
                    { t: 1, w: this.upsellTitleText },
                    { t: 1, w: this.savedText },
                    { t: 1, w: this.cartHeadingText },
                    { t: 1, w: this.itemSingularText },
                    { t: 1, w: this.itemPluralText },
                    { t: 1, w: this.freeText },
                    { t: 1, w: this.gift_with_purchase.progress_bar.locked_text_international },
                    { t: 1, w: this.gift_with_purchase.progress_bar.unlocked_text_international },
                    { t: 1, w: this.itemsText },
                  ],
                  languageTo: language,
                },
                async (data) => {
                  await data
                  console.log('** Translate Static Cart', data)
                  this.setCartTranslations(data)
                  sessionStorage.setItem(`_cart-translations`, JSON.stringify(data))
                }
              )
            }
            if (!baseUpsellTranslations) {
              const words = this.base_upsell_list.map((item) => {
                return { t: 1, w: item.title }
              })
              Weglot.translate({ words, languageTo: language }, async (data) => {
                await data
                sessionStorage.setItem(`_cart-translations-base-upsells`, JSON.stringify(data))
                if (data.length > 0) {
                  this.base_upsell_list.forEach((item, index) => {
                    this.base_upsell_list[index].title = data[index] ? data[index] : item.title
                  })
                }
              })
            }
            console.log('**this.base_upsell_list', this.base_upsell_list)
          }
        })
      } catch (e) {
        console.log('Translation failed: ', e)
      }
    }

    window.MicroBus.on('cart:added', async (e) => {
      this._setLoadingState(true)
      if (e.detail.toggle_side_cart != 'false') {
        window.MicroBus.emit(`side-cart:toggle`)
      }
      await this._setCart()
      await this._updateGWP()
      this._setLoadingState(false)
    })

    window.MicroBus.on('cart:add', async (e) => {
      if (e.detail.variant_id) {
        this._setLoadingState(true)
        let quantity = e.detail?.quantity ?? 1
        let selling_plan = e.detail?.selling_plan ?? null
        let properties = e.detail?.properties ?? {}
        if (this.bogo_enabled) {
          properties._uid = this.uuidv4()
        }
        try {
          await shopifyCart.add(quantity, e.detail?.variant_id, properties, selling_plan)
          if (e.detail.toggle_side_cart != 'false') {
            window.MicroBus.emit(`side-cart:toggle`)
          }
        } catch (e) {
          console.log(e)
        }
        await this._setCart()
        await this._updateGWP()
        this._setLoadingState(false)
      }
    })

    window.MicroBus.on('cart:change-quantity', async (e) => {
      const { key, quantity, item } = e.detail

      if (key && quantity != undefined) {
        this._setLoadingState(true)
        try {
          await shopifyCart.change(quantity, key)
          await this._setCart()
          await this._updateGWP()
        } catch (e) {
          console.log(e)
        }
        this._setLoadingState(false)
      }
    })

    window.MicroBus.on('cart:change-subscription-plan', async (e) => {
      const { key, selling_plan_id, quantity } = e.detail

      if (key && selling_plan_id != undefined) {
        this._setLoadingState(true)
        try {
          await shopifyCart.changeSellingPlan(selling_plan_id, key, quantity)
          await this._setCart()
          await this._updateGWP()
        } catch (e) {
          console.log(e)
        }
        this._setLoadingState(false)
      }
    })
  }

  async getInitialCart() {
    await this._setCart()
    await this._updateGWP()
  }

  _setLoadingState(state) {
    const el = this.shadowRoot.querySelector('.cart-drawer')
    this.loading = state
    el.setAttribute('loading', state)
  }

  _renderComparePrice(comparePrice, quantity = 1) {
    if (comparePrice) {
      return html`
        <s class="strikeout strikethrough-grey"
          >${this.currency_symbol + changeDecimalSeparator(centsToDollars(comparePrice * quantity))}</s
        >
      `
    }
  }

  _renderPrices(item, quantity, isBogo) {
    const price = item.original_price
    const discountedPrice = item.final_price
    const comparePrice = item.compare_at_price
    if (isBogo) {
      return html`
        <div class="price-container">
          <div class="free-text">${this.freeText}</div>
          ${this._renderComparePrice(comparePrice, quantity)}
        </div>
      `
    } else if (discountedPrice < price && comparePrice && comparePrice * quantity > price) {
      return html`
        <div class="price-container">
          <div>${this.currency_symbol + changeDecimalSeparator(centsToDollars(discountedPrice * quantity))}</div>
          ${this._renderComparePrice(comparePrice, quantity)}
        </div>
      `
    } else if (discountedPrice < price && (!comparePrice || comparePrice * quantity <= price)) {
      return html`
        <div class="price-container">
          <div>${this.currency_symbol + changeDecimalSeparator(centsToDollars(discountedPrice * quantity))}</div>
          ${this._renderComparePrice(price)}
        </div>
      `
    } else if (comparePrice && comparePrice * quantity > price) {
      return html`
        <div class="price-container">
          <div>${this.currency_symbol + changeDecimalSeparator(centsToDollars(discountedPrice * quantity))}</div>
          ${this._renderComparePrice(comparePrice, quantity)}
        </div>
      `
    } else {
      return html`
        <div class="price-container">
          <div>${this.currency_symbol + changeDecimalSeparator(centsToDollars(price * quantity))}</div>
        </div>
      `
    }
  }

  _variantTitle(variantTitle, productTitle) {
    variantTitle = productTitle ? variantTitle.replace(`${productTitle} /`, '') : variantTitle
    if (variantTitle) {
      return html`${variantTitle.replace(/ \//g, ',')}`
    }
  }

  _renderSubscription(item) {
    if (item?.selling_plan_allocation?.selling_plan?.name) {
      const selling_plan_name = item?.selling_plan_allocation?.selling_plan?.name
      return html` <div class="cart-item-subscription">${selling_plan_name}</div> `
    }
  }

  _sortByProp(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1
      } else if (a[prop] < b[prop]) {
        return -1
      }
      return 0
    }
  }

  _renderCartLineItems() {
    if (this.bogo_enabled) {
      /* const cartItemsPriceDecending = [...this.cartItems].sort(this._sortByProp('discounted_price')).reverse() */
      const bogoBucketArr = this.createBogoList(this.cartItems)
      // Check if at least one BOGO pair exists
      this.bogo_pair_found = bogoBucketArr.some((bucket) => bucket.type === 'paired')
      this._renderBOGOAnnouncementBar(this.bogo_pair_found)

      // cart item list container is needed to show the order coverage item from redo app
      return html`<div class="cart-item-list" style="margin:0">${this._renderBuckets(bogoBucketArr)}</div>`
    } else {
      this.totalSavings = this.ogTotalSavings
      return html`<ul class="cart-item-list">
        ${this.cartItems.map((item) => {
        return html`${this._renderLineItem(item)}`
      })}
      </ul> `
    }
  }

  createBogoList(cartItems) {
    // Define the script editor discount title
    const scriptEditorDiscountTitle = this.bogo_script_editor_discount_title

    // Array of eligible variant IDs for BOGO
    const eligibleProductIds = this.eligible_product_ids_array

    // Helper function to check if an item is free due to the script editor discount
    const isFreeItem = (item) => {
      return (
        item.discounted_price === 0 &&
        item.line_level_discount_allocations &&
        item.line_level_discount_allocations.some((alloc) => alloc.discount_application.title === scriptEditorDiscountTitle)
      )
    }

    // Helper function to check if an item is paid and eligible (has the specific tag)
    const isPaidEligibleItem = (item) => {
      return item.discounted_price > 0 && eligibleProductIds.includes(item.product_id)
    }

    // Filter and sort free items
    const freeItems = cartItems.filter(isFreeItem).sort(this._sortByProp('original_price')).reverse()

    // Filter and sort paid eligible items
    const paidEligibleItems = cartItems.filter(isPaidEligibleItem).sort(this._sortByProp('original_price')).reverse()

    // Items that are neither free nor paid eligible
    const nonEligibleItems = cartItems.filter((item) => !isFreeItem(item) && !isPaidEligibleItem(item))

    // Pair free and paid eligible items based on their value
    const bogoBucketArr = []

    for (let i = 0; i < paidEligibleItems.length; i++) {
      const paidItem = paidEligibleItems[i]
      const freeItem = freeItems[i]
      if (freeItem) {
        // Paired eligible items
        bogoBucketArr.push({ type: 'paired', items: [paidItem, freeItem] })
      } else {
        // Unpaired eligible item
        this.bogo_candidate = paidItem
        bogoBucketArr.push({ type: 'unpaired_eligible', items: [paidItem] })
      }
    }

    // Add non-eligible items, excluding those with item.product_type == "return,package_protection" of the order coverate redo item
    nonEligibleItems.forEach((item) => {
      if (item.product_type !== 'return,package_protection') {
        bogoBucketArr.push({ type: 'non_eligible', items: [item] })
      }
    })

    return bogoBucketArr
  }

  _renderDecrementButton(item, removeAll) {
    if (removeAll == true) {
      return html` <button
        class="flex-1"
        @click=${() => this._changeQuantity(item.key, 0, item.quantity, item)}
        aria-label="Remove all ${item.product_title} from cart"
      >
        <img src="${this.assets}/_trash-icon_v2.svg" />
      </button>`
    } else {
      return html`<button
        class="flex-1"
        @click=${() => this._changeQuantity(item.key, item.quantity - 1, item.quantity, item)}
        aria-label="Remove 1 ${item.product_title} from cart"
      >
        <img src="${this.assets}_minus-icon.svg" />
      </button>`
    }
  }

  _renderLineItem(item, isBogo) {
    let variantSwatch = null
    if (
      item.variant_title &&
      (item.options_with_values[0]?.name == 'Color' || item.options_with_values[0]?.name == 'Colour')
    ) {
      variantSwatch = item.variant_title
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, '-')
        .replace(/^-+|-+$/g, '')
    }

    let lineSavings = centsToDollars((item.compare_at_price - item.final_line_price) * item.quantity)

    return html` <li class="cart-item ${this.bogo_enabled == false ? 'cart-item-single-bucket' : ''}">
      <div class="flex cart-item_container">
        <div class="left cart-item_image-container">
          <a href="${item.url}">
            <img
              class="cart-item_image"
              src="${resizeImageSrc(item.featured_image.url, 120)}"
              width="80"
              height="80"
              alt=""
            />
          </a>
        </div>

        <div class="right flex flex-col justify-between self-center">
          <div class="flex justify-between gap-2">
            <div class="flex flex-col gap-1">
              <div class="flex flex-col gap-1">
                <a href="${item.url}" class="title">${item.product_title}</a>
                ${item?.selling_plan_allocation
        ? html`<div class="line-item-delivery-cadence">${item.selling_plan_allocation.selling_plan.name}</div>`
        : ''}
                ${item?.properties?._sale_inclusion_message
        ? html`<p style="color: #E71D06; margin: 0;">${item?.properties?._sale_inclusion_message}</p>`
        : ''}
              </div>

              ${!item.properties?._is_gift
        ? html`<div class="flex line-item-options-row">
                    ${item?.product_has_only_default_variant === false
            ? html` <div class="cart-item_variant-title">
                          ${variantSwatch ? html`<div class="variant-swatch ${variantSwatch}"></div>` : ''}
                          ${item.international_variant_title}
                        </div>`
            : null}
                  </div>`
        : ''}
            </div>
            <div class="cart-item--price-quantity">
              ${this._renderPrices(item, item.quantity, isBogo)}
              ${!item.properties?._is_gift
        ? html` <div class="quantity-selector flex">
                    ${this._renderDecrementButton(item, false)}
                    <input
                      type="number"
                      min="1"
                      max="99"
                      value=${item.quantity}
                      disabled
                      aria-label="total quantity of ${item.product_title} in cart"
                    />
                    <button
                      class="flex-1"
                      @click=${() => {
            if (this.bogo_enabled) {
              this._add(item)
            } else {
              this._changeQuantity(item.key, item.quantity + 1, item.quantity, item)
            }
          }}
                      aria-label="Add 1 ${item.product_title} to cart"
                    >
                      <img src="${this.assets}/_plus-icon.svg" />
                    </button>
                  </div>`
        : ''}
            </div>
          </div>
        </div>
      </div>

      ${this._renderSubscriptionUpsellButton(item)}

      <!-- ${item.selling_plan_allocation && !this.bogo_enabled
        ? html` <div class="cart-bucket-footer">
            <img src="${this.assets}/_tag-icon.svg" />
            <span>
              Subscribe & Save 20% applied! You’re saving ${this.currency_symbol + lineSavings}! Your product will be
              delivered every ${item.selling_plan_allocation.selling_plan.options[0].value}.
            </span>
          </div>`
        : ''} -->
    </li>`
  }

  async _fetchItemJSObject(item) {
    return await get(`/products/${item.handle}.js`)
  }

  _renderSubscriptionUpsellButton(item) {
    const subscriptionUpsellEnabled = this.subscription_upsell.enabled
    const alreadyWithSubscription = item.hasOwnProperty('selling_plan_allocation')
    let offerSubscriptionUpsell = false
    let selling_plans = []

    if (subscriptionUpsellEnabled) {
      if (!this.subscription_upsell.product.id) {
        if (item.hasOwnProperty('selling_plan_groups') && item.selling_plan_groups.length > 0) {
          offerSubscriptionUpsell = true
          selling_plans = item.selling_plan_groups?.[0]?.selling_plans || []
        }
      } else if (item.product_id == this.subscription_upsell.product.id) {
        selling_plans = this.subscription_upsell.product.selling_plan_groups?.[0]?.selling_plans || []
        offerSubscriptionUpsell = true
      }
    }

    if (item.product_id == '8086798762152') {
      // Skin Therapy Activating Serum
      if (item.id == '46601533096104') {
        // Refill
        selling_plans = selling_plans.slice(0, 3)
      } else {
        // 30ML
        selling_plans = selling_plans.slice(3, 6)
      }
    }

    return html`
      ${offerSubscriptionUpsell
        ? html`
            <div class="subscription-upsell-container">
              ${!alreadyWithSubscription
            ? html`
                    <button
                      class="btn-secondary subscription-upsell-btn"
                      @click=${() => this._handleSubscriptionUpsell(item, selling_plans)}
                    >
                      Upgrade to Subscription & save 20%
                    </button>
                  `
            : html`
                    <select class="subscription-upsell-select" @change=${() => this._handleSubscriptionUpsellOnChange(item)}>
                      ${selling_plans.map((plan) => {
              return plan.id == item.selling_plan_allocation.selling_plan.id
                ? html` <option value="${plan.id}" selected>${plan.name}</option> `
                : html` <option value="${plan.id}">${plan.name}</option> `
            })}
                    </select>
                  `}
            </div>
          `
        : ''}
    `
  }

  _handleSubscriptionUpsell(item, selling_plans) {
    const { key, quantity } = item
    const selling_plan_id = selling_plans?.[1]?.id

    window.MicroBus.emit('cart:change-subscription-plan', {
      key,
      selling_plan_id: selling_plan_id,
      quantity,
    })
  }

  _handleSubscriptionUpsellOnChange(item) {
    const { key, quantity } = item
    const selling_plan_id = this.shadowRoot.querySelector('.subscription-upsell-select').value

    window.MicroBus.emit('cart:change-subscription-plan', {
      key,
      selling_plan_id: selling_plan_id,
      quantity,
    })
  }

  _renderBuckets(bucketList) {
    this.totalSavings = 0
    return html`
      ${bucketList.map((bucket) => {
      let bucketSavings = 0
      const bucketType = bucket.type
      const items = bucket.items

      return html`<ul class="cart-bucket">
          ${items.map((item, itemIndex) => {
        let isBogoItem = false
        if (bucketType === 'paired') {
          // In a paired bucket, the second item is the free item
          isBogoItem = itemIndex === 1
        }

        // Calculate savings
        if (bucketType === 'paired' && isBogoItem) {
          // Free item in a paired bucket
          const savings = Number(centsToDollars(item.compare_at_price, false))
          this.totalSavings += savings
          bucketSavings += savings
        }

        return html`${this._renderLineItem(item, isBogoItem)}`
      })}

          <div class="cart-bucket-footer ${bucketType === 'paired' ? 'bogo-applied' : ''}">
            ${bucketType === 'paired'
          ? html`<img src="${this.assets}/_tag-icon.svg" />
                  <span>
                    ${this.bogo_script_editor_discount_title} | ${this.currency_symbol + dropZeros(bucketSavings.toFixed(2))}
                    ${this.savedText}
                  </span>`
          : bucketType === 'unpaired_eligible'
            ? html`${unsafeHTML(this.line_item_message_when_promo_is_not_active)}`
            : html`${unsafeHTML(this.line_item_content_when_item_is_not_eligible)}`}
          </div>
        </ul>`
    })}
    `
  }

  _renderCartTiles() {
    return html`${this.settings.empty_cart.tiles.map(
      (tile) => html`<a
        href="${tile.url}"
        class="empty-cart_tile-card"
        onclick="
        window.location.href = '${tile.url}';
        window.location.reload(true);"
      >
        <img src="${tile.image}" alt="${tile.image.alt}" class="empty-cart_tile-image" />
        <h2 class="empty-cart_tile-label">${tile.label}</h2>
      </a>`
    )}`
  }

  updated() {
    window.MicroBus.emit('side-cart:updated', { id: 'side-cart' })
  }

  _renderUpsells() {
    if (this.upsells?.length > 0) {
      /**
       * With this flag:
       * 1. Only shows 2 elements
       * 2. Shows elements on a list, not on a slider
       */
      let cartIsEmpty = this.count < 1

      let upsellTitle = this.upsellTitleText
      if (this.bogo_enabled && !cartIsEmpty) {
        upsellTitle = this.bogo_pair_found ? this.bogo_upsell_message : this.bogo_upsell_free_message
      }

      const cartBogoEligibleProductsArray = this.getCartBogoEligibleProducts()
      const renderCartBogoEligibleProductsArray = cartBogoEligibleProductsArray.length > 0

      return html`
        <div class="cart-drawer_upsells">
          <h2 class="side-cart-upsell-card-header">${upsellTitle}</h2>
          <div class="side-cart-upsell-products-container ${cartIsEmpty ? 'upsell-for-empty-cart' : ''}">
            <div>
              <ul class="side-cart-upsell-products">
                ${renderCartBogoEligibleProductsArray
          ? cartBogoEligibleProductsArray.map((product, index) => {
            const { url, image, product_title, price: product_price, compare_at_price, variant_id } = product
            let price = Number(centsToDollars(product_price, true)).toFixed(2).replace('.00', '')
            let comparePrice = Number(centsToDollars(compare_at_price, true)).toFixed(2)?.replace('.00', '')
            let showFree =
              this.bogo_enabled && this.cartItems.length % 2 != 0 && this.bogo_candidate?.price >= product.price
            return html`<li class="side-cart-upsell-card">
                        <div class="side-cart-upsell-card-image-container">
                          <a href="${url}">
                            <img src="${image}" width="125" height="125" alt="${product_title}" loading="lazy" />
                          </a>
                        </div>
                        <div class="side-cart-upsell-card-details">
                          <div class="side-cart-upsell-card-desc-container">
                            <a href="${url}" class="side-cart-upsell-card-title"> ${product_title} </a>
                            <div class="side-cart-upsell-card-price-container">
                              <span class="side-cart-upsell-card-price">
                                ${showFree ? this.freeText : `${this.currency_symbol + changeDecimalSeparator(price)}`}
                              </span>

                              ${comparePrice && comparePrice > price
                ? html` <span class="side-cart-upsell-card-compare-price"
                                    >${this.currency_symbol + changeDecimalSeparator(comparePrice)}
                                  </span>`
                : ''}
                            </div>
                            <add-button
                              class="side-cart-upsell-card-add-button-container"
                              data-variant-id="${variant_id}"
                              data-toggle="false"
                              data-product-title="${product_title}"
                              data-upsell-position="${index + 1}"
                              type="cart-upsell"
                            >
                              <button class="side-cart-upsell-card-add-button btn-secondary">${this.addToCartText}</button>
                            </add-button>
                          </div>
                        </div>
                      </li> `
          })
          : ''}
                ${this.upsells.map((product, index) => {
            const variant = product.variants?.[0]
            if (variant !== undefined) {
              let img = ''
              if (variant.featured_image?.url) {
                img = variant.featured_image.url
              } else {
                img = product.featured_image
              }
              let price = Number(centsToDollars(variant.price, true)).toFixed(2).replace('.00', '')
              let comparePrice = Number(centsToDollars(variant.compare_at_price, true)).toFixed(2)?.replace('.00', '')
              let showFree =
                this.bogo_enabled && this.cartItems.length % 2 != 0 && this.bogo_candidate?.price >= product.price

              // This is a temperoary fix to resolve a live issue
              if (this.enableGlobale) {
                showFree = false
              }
              return html`<li class="side-cart-upsell-card">
                      <div class="side-cart-upsell-card-image-container">
                        <a href="${product.url}">
                          <img src="${img}" width="125" height="125" alt="${product.title}" loading="lazy" />
                        </a>
                      </div>
                      <div class="side-cart-upsell-card-details">
                        <div class="side-cart-upsell-card-desc-container">
                          <a href="${product.url}" class="side-cart-upsell-card-title"> ${product.title} </a>
                          <div class="side-cart-upsell-card-price-container">
                            <span class="side-cart-upsell-card-price">
                              ${showFree ? this.freeText : `${this.currency_symbol + changeDecimalSeparator(price)}`}
                            </span>
                            ${showFree
                  ? html` <span class="side-cart-upsell-card-compare-price"
                                  >${this.currency_symbol + changeDecimalSeparator(comparePrice)}</span
                                >`
                  : ''}
                            ${comparePrice && comparePrice > price && !showFree
                  ? html` <span class="side-cart-upsell-card-compare-price"
                                  >${this.currency_symbol + changeDecimalSeparator(comparePrice)}
                                </span>`
                  : ''}
                          </div>
                          <add-button
                            class="side-cart-upsell-card-add-button-container"
                            data-variant-id="${variant.id}"
                            data-toggle="false"
                            data-product-title="${product.title}"
                            data-upsell-position="${index + 1}"
                            type="cart-upsell"
                          >
                            <button class="side-cart-upsell-card-add-button btn-secondary">${this.addToCartText}</button>
                          </add-button>
                        </div>
                      </div>
                    </li> `
            }
          })}
              </ul>
            </div>
          </div>
        </div>
      `
    }
  }

  getCartBogoEligibleProducts() {
    // Early exit if cat bogo metaobject is not enabled or there are no items in the cart
    const { is_cart_bogo_enable, eligible_product_ids_array } = this.cart_bogo_metaobject_settings
    if (!is_cart_bogo_enable || !this.cartItems.length) return []

    // Filter eligible cart items based on product ID
    const getEligibleCartItems = this.cartItems.filter((item) => eligible_product_ids_array.includes(item.product_id))

    // Count occurrences of each eligible item by its `product_id`
    const itemCounter = getEligibleCartItems.reduce((acc, item) => {
      acc[item.product_id] = (acc[item.product_id] || 0) + 1
      return acc
    }, {})

    // Filter items with a count of 1, meaning they appear only once
    const cartItemsToRender = getEligibleCartItems.filter((item) => itemCounter[item.product_id] === 1)

    // Return items or empty array
    return cartItemsToRender.length ? cartItemsToRender : []
  }

  _renderFreeShipping() {
    if (this.subtotal >= this.free_shipping_threshold) {
      return html`
        <span class="strikeout strikethrough-grey">${this.base_shipping_price}</span>
        <span class="free-text font-red">${this.freeText}</span>
      `
    } else {
      return html`${this.base_shipping_price}`
    }
  }

  _renderCartBottom() {
    if (this.count > 0 && this.cartItems) {
      let paymentPlan =
        this.enableGlobale == true
          ? ''
          : html`<div class="cart-drawer_bottom-payments">
              or 4 interest-free payments of ${changeDecimalSeparator(this.currency_symbol + (this.subtotal / 4).toFixed(2))}
            </div>`
      let savingsMessage = this.savingsText
      let savings = this.totalSavings
      if (this.bogo_enabled) {
        savingsMessage = this.bogo_savings_message
        savings = this.ogTotalSavings
      }

      return html`
        <div class="cart-drawer_bottom">
          ${savings > 0
          ? html`
                <div class="cart-drawer_bottom-savings cart-drawer_bottom-label">
                  <div class="font-red">${savingsMessage}</div>
                  <span class="font-red">- ${this.currency_symbol + changeDecimalSeparator(savings)}</span>
                </div>
              `
          : ''}
          <div
            class="asdf cart-drawer_bottom-savings cart-drawer_bottom-label ${this.enableGlobale == true ? 'hidden' : ''}"
          >
            <div class="">Shipping</div>
            <span> ${this._renderFreeShipping()} </span>
          </div>
          <div class="flex justify-between order-total">
            <div class="cart-drawer_bottom-subtotal cart-drawer_bottom-label">
              ${this.enableGlobale ? this.subTotalText : 'Estimated Total'}
            </div>
            <div class="cart-drawer_bottom-total cart-drawer_bottom-label">
              <div>
                ${this.currency_symbol}${this.subtotal < this.free_shipping_threshold && !this.enableGlobale
          ? changeDecimalSeparator(centsToDollars(Number(this.subtotal) * 100 + 999))
          : changeDecimalSeparator(this.subtotal)}
              </div>
            </div>
          </div>
          ${paymentPlan}
          <a
            class="btn-primary text-xs"
            id="checkout"
            href="/checkout"
            @click=${this._trackGoToCheckout}
          >
            <img src="${this.assets}_lock_icon_v2.svg" alt="secure lock icon" width="14" height="20" />&nbsp;
            ${this.checkoutText}
          </a>
          <div class="cart-drawer_bottom__message">
            <img
              src="${this.assets}_stars_with_gradient.svg"
              alt="Five stars from 700 000+ happy customers"
              width="100"
              height="24"
            />
            <span>700,000+ HAPPY CUSTOMERS</span>
          </div>
        </div>
      `
    }
  }

  _renderEmptyCartBottom() {
    return html`
      <div class="cart-drawer_bottom" style="display: none">
        <a href="${this.emptyCartShopURL}" class="btn-primary">${this.emptyCartButton}</a>
      </div>
      <div class="cart-drawer_value-props" style="display: none">
        <div class="${this.enableGlobale ? 'hidden' : ''}">Free shipping*</div>
        <div class="${this.enableGlobale ? 'hidden' : ''}">•</div>
        <div>${this.enableGlobale ? this.valuePropReturns : '60 Day Free Trial'}</div>
        <div>•</div>
        <div>${this.valuePropWarranty}</div>
      </div>
    `
  }

  _trackGoToCheckout() {
    if (Shopify.analytics) {
      Shopify.analytics.publish("side_cart_click_checkout_btn", {
        items: this.cartItems.map((item) => {
          return {
            id: item.id,
            name: item.title,
            category: item.type,
            variant: item.variant_title,
            list_name: 'Cart Drawer',
            quantity: item.quantity,
            price: item.price,
          }
        }),
        value: this.subtotal,
        currency: 'USD',
      });
    }
  }

  _renderCartBody() {
    const isEmpty = this.count === 0 ? 'is-empty' : ''
    return html`
        <div class="cart-drawer_products-container">
          <div class="cart-drawer_products-line-container relative">
            <div class="loading-container">
              <img class="loading-spinner" width="50" height="50" src="${this.assets}_loading-tail-spin.svg" />
            </div>
            <div class="cart-drawer_bucket-container">
              ${this._renderGiftProgressBar()}
              ${this._renderCartLineItems()}
            </div>
            ${isEmpty
        ? this._renderEmptyCart()
        : html`<div class="cart-drawer_upsells-container ${isEmpty}">${this._renderUpsells()}</div>`
      }
          </div>

          </div>
          <div>${this._renderCartBottom()}</div>
        </div>
      `
  }

  _renderEmptyCart() {
    if (this.base_upsell_list) {
      this.upsells = this.base_upsell_list
    }
    let empty_cart_content
    if (this.bogo_enabled) {
      empty_cart_content = `
      <div class="empty-cart-bogo_wrapper">
        <div class="empty-cart-bogo_promo-message">
          ${this.empty_cart_promo_message}
        </div>
        <div class="empty-cart-bogo_reviews">
              <img
                src="${this.assets}_stars_with_gradient.svg"
                alt="Five stars from 700 000+ happy customers"
                width="100"
                height="24"
              />
              <span>700,000+ HAPPY CUSTOMERS</span>
              <p>Scientifically Backed,<br>Award-Winning Skincare</p>
        </div>
      </div>
      `
    } else {
      empty_cart_content = `<p class="empty-cart_text">${this.empty_cart.text}</p>`
    }
    return html`
      <div class="empty-cart">
        ${unsafeHTML(empty_cart_content)}
        ${this.upsells
        ? html`<div class="cart-drawer_upsells-container">${this.upsells.length > 0 ? this._renderUpsells() : ''}</div> `
        : ''}
        <div>${this._renderEmptyCartBottom()}</div>
      </div>
    `
  }

  _renderCartCount() {
    if (this.count > 0) {
      return html`${this.count}`
    }
  }

  _renderGiftProgressBar() {
    if (this.gift_with_purchase?.enabled && !this.gift_with_purchase.product_threshold?.id) {
      return html`<free-gift-progress
        .subtotal=${this.gift_with_purchase.consider_original_price ? this.originalSubTotal : this.subtotal}
        free-gift-min="${this.gift_with_purchase.threshold / 100}"
        locked-text="${this.enableGlobale
          ? this.gift_with_purchase.progress_bar.locked_text_international
          : this.gift_with_purchase.progress_bar.locked_text}"
        unlocked-text="${this.enableGlobale
          ? this.gift_with_purchase.progress_bar.unlocked_text_international
          : this.gift_with_purchase.progress_bar.unlocked_text}"
      ></free-gift-progress>`
    } else {
      return html``
    }
  }

  render() {
    // Flag to hide cart counter when cart is empty
    let cartIsEmpty = this.count < 1
    return html`
      <div class="cart-drawer tailwind ${this.gift_with_purchase?.enabled ? 'gwp-enabled' : ''}" loading="false">
        <div class="cart-drawer_header">
          <div class="cart-drawer_header-details">
            <h3 class="cart-drawer_title">${this.cartHeadingText} ${this.count < 1 ? 'is empty' : ''}</h3>
            <span class="cart-drawer_cart-count font-light ${cartIsEmpty ? 'hide-element-empty-cart' : ''}">
              ${this.count} ${this.itemsText}
            </span>
          </div>
        </div>
        ${this._renderAnnouncementBar()} ${this._renderCartBody()}
      </div>
    `
  }
  _renderAnnouncementBar() {
    if (this.announcementText != '') {
      return html`<div class="cart-announcement-bar">${this.announcementText}</div>`
    }
  }

  _renderBOGOAnnouncementBar(bogo_pair_found) {
    const isEmpty = this.count === 0
    const announcementBar = this.shadowRoot.querySelector('.cart-announcement-bar')
    if (announcementBar && !isEmpty) {
      announcementBar.innerText = bogo_pair_found
        ? this.line_item_content_when_item_is_active
        : this.line_item_message_when_promo_is_not_active
    }
  }

  _changeQuantity(key, quantity, currentQuantity, item) {
    window.MicroBus.emit('cart:change-quantity', {
      key: key,
      quantity: quantity,
      item: item,
    })
    if (window?.gtag) {
      if (quantity != 0 && quantity > currentQuantity) {
        window.gtag('event', `Side Cart - Quantity Increase`, {
          event_detail: item.variant_id,
        })
      } else if (quantity != 0 && quantity < currentQuantity) {
        window.gtag('event', `Side Cart - Quantity Decrease`, {
          event_detail: item.variant_id,
        })
      } else if (quantity == 0) {
        window.gtag('event', `Side Cart - Remove Item`, {
          event_detail: item.variant_id,
        })
      }
    }
  }
  _add(item) {
    window.MicroBus.emit('cart:add', {
      variant_id: item.variant_id,
      quantity: 1,
      properties: item.properties ? item.properties : {},
      toggle_side_cart: 'false',
    })
    if (window?.gtag) {
      window.gtag('event', `Side Cart - Add Item`, {
        event_detail: item.variant_id,
      })
    }
  }
}

customElements.define('cart-drawer', CartDrawer)
